import Config from '@config';

import { injectBmsSlice } from '@/app/bmsApi';
import { CACHE_EXPIRATION_TIME } from '@/features/constants';

import { UserPermissionType } from '@components/Permissions/types';

export const permissionsApi = injectBmsSlice({
  baseUrl: Config.VITE_API_URL + '/users',
  tagTypes: ['UserPermissions'],
  keepUnusedDataFor: CACHE_EXPIRATION_TIME,
  endpoints: builder => ({
    getUserPermissions: builder.query<UserPermissionType[], void>({
      query: () => ({
        url: `/permissions`,
      }),
      providesTags: ['UserPermissions'],
    }),
  }),
});

export const { useGetUserPermissionsQuery } = permissionsApi;
